<template>
  <div class="account-setting">
    <b-loading :active="loading" />
    <h1 class="page-title">
      公司帳戶
      <small class="subtitle">此處可以查看/調整公司資訊。</small>
    </h1>
    <div class="account-setting__content">
      <div class="columns">
        <div class="column is-half-desktop is-full-mobile is-full-tablet">
          <div class="setting-card">
            <h3 class="setting-card__title actionable">
              <span>帳戶資訊</span>
              <router-link
                class="button is-primary"
                to="setting/plans">
                方案管理
              </router-link>
            </h3>
            <div class="setting-card__content">
              <b-field
                horizontal
                label="公司名稱"
                :message="teamInfo.name ? '' : '預設為註冊時的公司/組織名稱'">
                <b-input
                  v-model="teamInfo.name"
                  @input="v$.teamInfo.name.$touch" />
              </b-field>
              <b-field
                class="h-10 items-center"
                horizontal
                label="統一編號">
                {{ identification }}
              </b-field>
              <b-field
                class="h-10 items-center"
                horizontal
                label="目前方案">
                {{ planName || '--' }}
              </b-field>
              <b-field
                class="h-10 items-center"
                horizontal
                label="點餐平台顯示領取條碼">
                <b-switch
                  v-model="teamInfo.enablePickupCode"
                  class="mx-2"
                  size="is-small"
                  @input="v$.teamInfo.enablePickupCode.$touch"
                />
              </b-field>
              <b-field
                horizontal
                label="自動完成訂購">
                <div>
                  <div class="flex flex-col">
                    <b-switch
                      v-model="teamInfo.autoCompleteGroupBuying"
                      size="is-small"
                      @input="v$.teamInfo.autoCompleteGroupBuying.$touch"
                    />
                    <div
                      v-if="teamInfo.autoCompleteGroupBuying"
                      class="flex flex-wrap items-center"
                    >
                      <span>領取時段結束後</span>
                      <div class="flex items-center">
                        <span>第</span>
                        <b-field
                          :type="v$.teamInfo.autoCompleteDays.$error ? 'is-danger' : undefined"
                          :message="
                            v$.teamInfo.autoCompleteDays.$error
                              ? v$.teamInfo.autoCompleteDays.$errors[0]?.$message
                              : undefined
                            "
                          class="mb-0"
                        >
                          <b-select
                            v-model="teamInfo.autoCompleteDays"
                            size="is-small"
                            @input="v$.teamInfo.autoCompleteDays.$touch">
                            <option v-for="n in 30" :key="n" :value="n">{{ n }}</option>
                          </b-select>
                        </b-field>
                        <span class="ml-2">天自動完成</span>
                      </div>
                    </div>
                  </div>
                  <p class="help">
                    <span class="icon-info-round-circle" /> 請注意：已完成的訂單將不可進行核銷及收款
                  </p>
                </div>
              </b-field>
              <div class="is-pulled-right">
                <w-button
                  v-if="v$.teamInfo.$anyDirty"
                  size="sm"
                  :disabled="v$.teamInfo.$invalid"
                  @click="onSubmitTeamInfo">儲存</w-button>
              </div>
              <div class="is-clearfix"></div>
            </div>
          </div>

          <div v-if="false" class="setting-card">
            <h3 class="setting-card__title">
              網域資訊
            </h3>
            <div class="setting-card__content">
              <b-field
                horizontal
                label="點餐預設網址">
                --
              </b-field>
              <b-field
                horizontal
                label="自訂名稱">
                <b-input placeholder="長度為6-20個字元" />
              </b-field>
              <b-field
                horizontal
                label="自訂網址(URL)">
                www.takeorder.tw/c/自訂名稱
              </b-field>
            </div>
          </div>
        </div>
        <div class="column is-half-desktop is-full-mobile is-full-tablet">
          <div class="setting-card">
            <h3 class="setting-card__title setting-card__title--compact">
              部門設定
              <small>可以新增/更換/刪除部門名稱</small>
            </h3>
            <div class="setting-card__content setting-card__content--compact">
              <draggable
                v-model="departmentInfo.departments"
                handle=".drag-trigger"
                @change="v$.departmentInfo.departments.$touch">
                <b-field
                  v-for="(department, index) in departments"
                  horizontal
                  class="field__department"
                  :key="`department-${index}-${department}`">
                  <template #label>
                    <div class="drag-trigger">
                      <span class="icon-drag" />
                      部門 {{ index + 1 }}
                    </div>
                  </template>
                  <b-input
                    v-model="departments[index].name"
                    @input="v$.departmentInfo.departments.$touch" />
                  <a href="#" @click.prevent="onRemoveDepartment(index)">
                    <span class="icon-trash" />
                  </a>
                </b-field>
              </draggable>
              <b-field horizontal class="field__add-department">
                <w-button
                  color-type="secondary"
                  size="sm"
                  type="link"
                  @click.prevent="onCreateDepartment"
                >
                  <span class="icon-plus text-xs" />
                  <span class="ml-2">添加更多部門</span>
                </w-button>
              </b-field>
              <div class="is-pulled-right">
                <w-button
                  v-if="v$.departmentInfo.$dirty"
                  size="sm"
                  @click="onSubmitDepartment">儲存</w-button>
              </div>
              <div class="is-clearfix" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Overview from './Overview';

export default Overview;
</script>

<style lang="scss" scoped>
@import 'Overview';
</style>
